// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2rAjg","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2Njr-"};